import { Component, ChangeDetectionStrategy } from '@angular/core';
import { CsPage, NavController } from 'providers/nav-controller';
import { SettingsService } from 'services/settings.service';
import { AuthService } from 'services/auth.service';
import { LoggingService } from 'services/logging.service';
import { TranslatedString } from 'models/translated-string';
import { HelpCardPageParams } from './help-card-page-interface';

export interface PreviewHelpText {
  title: TranslatedString;
  text: TranslatedString;
}

@Component({
    selector: 'page-help-card',
    templateUrl: 'help-card-page.html',
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class HelpCardPage extends CsPage<HelpCardPageParams> {
  helpId: string;
  helpTextMarkdown: string;
  header: string;

  constructor(
    public navCtrl: NavController,
    private settings: SettingsService,
    protected auth: AuthService,
    public logging: LoggingService,
  ) {
    super();

  }

  async ionViewWillEnter() {
    this.helpId = this.navParams.data.helpId;
    if (this.helpId && this.helpId !== '') {
      let mySettings = JSON.parse(this.settings.helpSeenJSON || '{}') || {};
      mySettings[this.helpId] = true;
      this.settings.helpSeenJSON = JSON.stringify(mySettings);
    } else {
      let previewHelpText: PreviewHelpText = JSON.parse(window.localStorage.getItem('previewHelpText'));
      if (previewHelpText) {
        this.header = previewHelpText.title;
        this.helpTextMarkdown = previewHelpText.text;
      }
    }
  }

  // Note: Callbacks are now handled via the returnCallback mechanism in NavController.
  // Parent pages should use returnCallback param instead of passing callback functions.
}
